import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const DayHeader = ({children, label, drillDownView, onDrillDown, date, ...props}) => {
  return (
    <div className="maats-calendar-month-date-header">
      <Link
        to={{ pathname:'/calendar/create-work-order', query: { start: date.toISOString() } }}
        className='date-header-action-button add'
      />
      <a href="#" onClick={onDrillDown} style={{textDecoration: 'none'}}>
        {label}
      </a>
    </div>
  )
}

DayHeader.propTypes = {
  label: PropTypes.node,
  date: PropTypes.instanceOf(Date),
  drilldownView: PropTypes.string,
  onDrillDown: PropTypes.func,
  isOffRange: PropTypes.bool,
}

export default DayHeader



// WEBPACK FOOTER //
// ./src/components/calendar/day-header.js